import { Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import React from 'react'
import {
    ConfirmationDialog,
    useConfirmationDialogController,
} from '../../presentation/confirmation-dialog'

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.dark,
    },
}))

const FeatureToggleRow = ({ name, description, value, setValue, loading, errorMsg, disabled }) => {
    const classes = useStyles()

    const onConfirm = () => setValue(!value)

    const dialogController = useConfirmationDialogController({ onConfirm })

    const confirmMsg = `Are you sure you want to ${value ? 'disable' : 'enable'} ${name}`

    return (
        <Paper {...getContainerProps(errorMsg)}>
            <ConfirmationDialog message={confirmMsg} controller={dialogController} />
            <Grid container>
                <Grid className={classes.cell} item xs={3}>
                    <Typography variant="body1">{name}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={6}>
                    <Typography variant="body1" align="center">{description}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={3}>
                    <Switch
                        disabled={value === undefined || loading || disabled}
                        checked={!!value}
                        color="primary"
                        onChange={dialogController.openDialog}
                    />
                </Grid>
            </Grid>
            {errorMsg ? (
                <Grid item xs={12}>
                    <Typography variant="body1" align="center" className={classes.errorText}>
                        {errorMsg}
                    </Typography>
                </Grid>
            ) : (
                <></>
            )}
        </Paper>
    )
}

const getContainerProps = (errorMsg) => {
    const classes = useStyles()

    return {
        className: classes.container + (errorMsg ? ' ' + classes.errorBorder : ''),
        variant: errorMsg ? 'outlined' : undefined,
        elevation: 0,
    }
}

export default FeatureToggleRow
